import * as ErrorActions from './error.actions';

export interface State {
  errorHttp: any;
}

const initialState: State = {
  errorHttp: null
};

export function errorReducer(state = initialState, action: ErrorActions.ErrorActions) {
  switch (action.type) {
    case (ErrorActions.SET_HTTP_ERROR):
      console.log('Set Http Error', action.payload);
      return {
        ...state,
        errorHttp: action.payload
      };
  }
  return state;
}
